import { registerStore } from '../../common/utilsClient/multiReducer';

const store = registerStore({
  path: 'ui.screens.SettingsNoticeBoard',
  initialState: {
    currentNoticeId: null,
    isEditNoticeDialogVisible: false,
    searchQuery: '',
  },
});

export const getCurrentNoticeId = store.get('currentNoticeId');
export const setCurrentNoticeId = store.create.set('currentNoticeId');

export const getIsEditNoticeDialogVisible = store.get(
  'isEditNoticeDialogVisible',
);

export const setIsEditNoticeDialogVisible = store.create.set(
  'isEditNoticeDialogVisible',
);

export const openEditNoticeDialog = (noticeId) => (dispatch) => {
  if (noticeId) {
    dispatch(setCurrentNoticeId(noticeId));
  }
  dispatch(setIsEditNoticeDialogVisible(true));
};

export const closeEditNoticeDialog = () => (dispatch) => {
  dispatch(setIsEditNoticeDialogVisible(false));
  dispatch(setCurrentNoticeId(null));
};

export const getSearchQuery = store.get('searchQuery');
export const setSearchQuery = store.create.set('searchQuery');

export default store;
